import axiosConfig from "./axiosConfig";

export interface PRPeriod {
  pct: number;
  ryg: string | null;
  periodLabel: string;
  startDate: string;
  endDate: string;
  prevMonthDelta?: number | null;
  gprPct?: number | null;
  designedPrPct?: number | null;
  /** @deprecated use gprPct */
  contractedPct?: number | null;
}

export interface CurtailmentPeriodStats {
  curtailedPeriods: number;
  totalPeriods: number;
  curtailmentPct: number;
  estimatedLostGenerationKwh: number;
  periodsExcludedFromPR: number;
}

export interface CurtailmentStats {
  lastMonth: CurtailmentPeriodStats | null;
  last12Months: CurtailmentPeriodStats | null;
}

export interface PRPeriodPair {
  lastMonth: PRPeriod | null;
  last12Months: PRPeriod | null;
}

export interface SitePRResponse {
  gpr: PRPeriodPair | null;
  opr: PRPeriodPair | null;
  /** Curtailment-deemed variants: curtailed periods credited at modelled
   * potential rather than dropped. Identical to gpr/opr on an uncurtailed site. */
  gprDeemed?: PRPeriodPair | null;
  oprDeemed?: PRPeriodPair | null;
  curtailment: CurtailmentStats | null;
  /**
   * When set, the backend produced no PR figures and this string explains why
   * (e.g. monitoring not enabled, no actuals ingested yet, no complete month
   * yet). Frontend should render verbatim.
   */
  noDataReason?: string | null;
}

const getSitePR = async (
  authToken: string,
  siteId: string
): Promise<SitePRResponse> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/health/pr`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getSitePR;
